import { render, staticRenderFns } from "./fix-side-comment.vue?vue&type=template&id=64d6e2bc&scoped=true"
import script from "./fix-side-comment.vue?vue&type=script&lang=js"
export * from "./fix-side-comment.vue?vue&type=script&lang=js"
import style0 from "./fix-side-comment.vue?vue&type=style&index=0&id=64d6e2bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d6e2bc",
  null
  
)

export default component.exports